import createDataState from 'analyse2/createDataState'
import { dbState } from 'analyse2/db'

const dataState = createDataState(dbState)

export default dataState